// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".oildataPicker1 .el-date-editor{height:1.667vw!important;width:18.75vw!important;border-radius:0!important}.oildataPicker1 .el-date-editor .el-input__icon,.oildataPicker1 .el-date-editor .el-range-separator{line-height:1.25vw!important}", ""]);
// Exports
module.exports = exports;
